import React from 'react'
import './ProjectCard.scss'

function ProjectCard({ Title, Description, Stack, Image, Link }) {
    return (
        <div className='projectcard'>

            {/* <div className='inner-container'>

               

                    <div>
                        somting
                    </div>

                    <div>
                        <h4>Digital Transformation</h4>
                        <p>Leveraging cutting-edge technologies to transform traditional business processes into streamlined digital workflows.</p>
                    </div>
                
            </div> */}


        </div>
    )
}

export default ProjectCard